module.exports = __webpack_public_path__ + "static/img/6.6f5e4d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/mid-autumn/guide/6.jpg
// module id = 4ztB
// module chunks = 1